import ChangeAllPlacementCard from 'Components/Editor/Details/ChangeAllPlacements/ChangeAllPlacementCard';
import ChangeAllPlacementSlider from 'Components/Editor/Details/ChangeAllPlacements/ChangeAllPlacementSlider';
import { DetectionAngleSpecification } from 'Models/Project/ProjectFilterSpecifications';
import EditorVideoDetection from 'Models/Videos/Detections/EditorVideoDetection';
import { ReactElement } from 'react';

interface ChangeAllPlacementCardAngleProps {
	angle: DetectionAngleSpecification | null;
	onAngleChanged: (angle: DetectionAngleSpecification | null) => void;
	selectedDetections: EditorVideoDetection[];
}

const INITIAL_ANGLE_VALUE: DetectionAngleSpecification = { from: 0, to: 0 };

const MIN_VALUE = -180;
const MAX_VALUE = 180;

const ChangeAllPlacementCardAngle = (props: ChangeAllPlacementCardAngleProps): ReactElement => {
	const isChecked = props.angle !== null;
	const fromValue = props.angle?.from ?? 0;
	const toValue = props.angle?.to ?? 0;

	const marks = Array.from(Array(9).keys()).map((x) => ({
		value: x * 45,
		label: `${x * 45}°`,
	}));

	const handlePlacementCardCheckedChanged = (checked: boolean): void => {
		const defaultValue = INITIAL_ANGLE_VALUE;
		if (props.selectedDetections.length > 0) {
			defaultValue.from = props.selectedDetections.reduce(
				(acc, x) => (x.angle < acc ? x.angle : acc),
				Number.MAX_SAFE_INTEGER
			);
			defaultValue.to = props.selectedDetections.reduce((acc, x) => (x.angle > acc ? x.angle : acc), 0);
		}
		if (checked) props.onAngleChanged(defaultValue);
		else props.onAngleChanged(null);
	};

	const setValues = (from: number, to: number): void => {
		props.onAngleChanged({ from, to });
	};

	return (
		<ChangeAllPlacementCard
			name="Select angle"
			onCheckedChanged={handlePlacementCardCheckedChanged}
			isChecked={isChecked}
		>
			<ChangeAllPlacementSlider
				label="Angle"
				fromValue={fromValue}
				toValue={toValue}
				min={MIN_VALUE}
				max={MAX_VALUE}
				marks={marks}
				onValuesChanged={setValues}
			/>
		</ChangeAllPlacementCard>
	);
};

export default ChangeAllPlacementCardAngle;
